<button class="btn btn-primary" (click)="startPayment()" [disabled]="loading">
  Pay Now
</button>

<div *ngIf="sessionUrl" class="iframe-wrapper">
  <iframe [src]="sessionUrl | safeUrl" width="100%" height="600" frameborder="0">
  </iframe>
</div>
